import React, {Component} from 'react';
import './styles/Footer.css';
import pckg from '../../../../../pckg';

export default class Footer extends Component{

    render(){

        return(
            <footer className="footer">
                <div className="container-fluid">
                    <nav className="pull-left">
                        <ul>
                            <li>
                                <a href="https://amcemig.com/">
                                    © {new Date().getFullYear()} AMCEMIG
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <div className="copyright pull-right">
                        v {pckg.version}
                        {/*Made with <i className="fa fa-heart heart" /> by <a href="https://tide.mx" target="_blank" rel="noopener noreferrer" >TIDE</a>*/}
                    </div>
                </div>
            </footer>
        );
    }

}



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/Footer/index.jsx